import React from "react";

import ContentPresenter from "./ContentPresenter";

export default class extends React.Component {

  render() {
    return <ContentPresenter/>;
  }
}
